var particle_endPS = `
#ifdef PCFOG
	rgb = addFog(rgb);
#endif
	rgb = toneMap(rgb);
	rgb = gammaCorrectOutput(rgb);
	gl_FragColor = vec4(rgb, a);
}
`;

export { particle_endPS as default };
